export default __webpack_public_path__ + "static/media/hulu.e55ad461.jpg";